import type { CallUiState } from '@domain/call/types';

export function hasPlayableVideo(stream: MediaStream | null) {
  return stream?.getVideoTracks().some((track) =>
    track.readyState === 'live' && track.enabled && !track.muted,
  ) === true;
}

export function videoCallStatus(state: CallUiState) {
  if (state === 'dialing') return '呼叫中…';
  if (state === 'connecting') return '正在连接…';
  if (state === 'connected') return '等待视频画面…';
  if (state === 'error') return '连接失败';
  if (state === 'ended') return '通话已结束';
  return '等待接听…';
}
